module.exports = __webpack_public_path__ + "static/media/platebody-1.76297ef3.glb";